import { Row, Col } from "react-bootstrap";
import { Ring } from "react-awesome-spinners";

export const LoadingSpinner = ({ message = "Please wait..." }) => (
  <>
    <Row className="m-3 ">
      <Col className="text-center mb-5">
        <Ring size={100} />
      </Col>
    </Row>
    <Row className="m-3 ">
      <Col className="text-center">
        <h6>{message}</h6>
      </Col>
    </Row>
  </>
);